// Recovered compiled webpack factory 80266. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { d: () => n });
  class n extends Error {
    constructor(e = "WebGL is unavailable on this device.", t, r) {
      (super(e), (this.cause = t), (this.browserReason = r), (this.name = "WebGLUnsupportedError"));
    }
  }
}
